export const environment = {
  production: false,
  productLogo: '/assets/logo/VIGIL CENTRAL_WHITE-White.svg',
  features: {},
};
